module.exports = __webpack_public_path__ + "app-static/img/no-data.c95620ca.png";